import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";
import { ExclamationOutlined, CloseOutlined } from "@ant-design/icons";
import { UiModal, UiWaringModal, UiErrorModal } from "./Modal.style";
/**
 * 彈窗組件
 */

const Modal = ({
  closable = true,
  title = "",
  visible,
  confirmLoading,
  okText = "確定",
  cancelText = "取消",
  okButtonProps,
  onOk,
  onCancel,
  footer,
  getContainer = false,
  width = "520px",
  children
}) => {
  return /*#__PURE__*/React.createElement(UiModal, {
    closable: closable,
    width: width,
    title: title,
    visible: visible,
    confirmLoading: confirmLoading,
    okText: okText,
    cancelText: cancelText,
    okButtonProps: okButtonProps,
    onOk: onOk,
    onCancel: onCancel,
    getContainer: getContainer,
    footer: footer
  }, children);
};

export default Modal;
Modal.propTypes = {
  closable: PropTypes.bool,
  title: PropTypes.node,
  visible: PropTypes.bool,
  confirmLoading: PropTypes.bool,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  okButtonProps: PropTypes.object,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  footer: PropTypes.node,
  getContainer: PropTypes.any,
  width: PropTypes.string,
  children: PropTypes.node
};
export const WarningModal = ({
  visible,
  onOk,
  onCancel,
  message = "該名稱已被其他資料使用，確定要儲存？"
}) => {
  return /*#__PURE__*/React.createElement(UiWaringModal, {
    visible: visible,
    onOk: onOk,
    onCancel: onCancel,
    closable: false,
    footer: [/*#__PURE__*/React.createElement(Button.IconButton, {
      key: "back",
      variant: "white",
      onClick: onCancel,
      icon: /*#__PURE__*/React.createElement("i", {
        className: "material-icons",
        style: {
          fontSize: "20px"
        }
      }, "close"),
      full: false
    }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(Button.IconButton, {
      key: "submit",
      variant: "blue",
      onClick: onOk,
      icon: /*#__PURE__*/React.createElement("i", {
        className: "material-icons",
        style: {
          fontSize: "20px"
        }
      }, "panorama_fish_eye"),
      full: false
    }, "\u78BA\u5B9A")]
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/React.createElement(ExclamationOutlined, null)), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, message)));
};
WarningModal.propTypes = {
  visible: PropTypes.bool,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  message: PropTypes.string
};
export const ErrorModal = ({
  visible,
  onCancel,
  message = "名稱、作答方式、預設列印方式欄位不得空白"
}) => {
  return /*#__PURE__*/React.createElement(UiErrorModal, {
    visible: visible,
    onCancel: onCancel,
    closable: false,
    footer: [/*#__PURE__*/React.createElement(Button.IconButton, {
      key: "back",
      variant: "white",
      onClick: onCancel,
      icon: /*#__PURE__*/React.createElement("i", {
        className: "material-icons",
        style: {
          fontSize: "20px"
        }
      }, "close"),
      full: false
    }, "\u53D6\u6D88")]
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/React.createElement(CloseOutlined, null)), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, message)));
};
ErrorModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  message: PropTypes.string
};